export default __webpack_public_path__ + "static/Mont-ThinItalic-37121e980280bd8858087099157d9dfb.otf";